// extracted by mini-css-extract-plugin
export default {"activeLink":"LayoutWithSideMenu_activeLink__lwlWt"};